import { PageHeader, CTABand, Counter } from "../components/ui-blocks";
import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { INDUSTRIES } from "../data";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader overline="Industries We Serve" title="Specialists in the sectors that power the economy" subtitle="We don't spread thin. Our recruiters live inside their industries — speaking the language, knowing the talent, and vetting for what actually matters." />

      <section className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.name} delay={i * 0.05}>
                <div data-testid={`industry-detail-${ind.name.split(" ")[0].toLowerCase()}`} className={`group grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-3xl border border-slate-800/80 overflow-hidden bg-[#111827]/60 hover:border-amber-500/40 transition-all duration-300 ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
                  <div className="relative h-64 lg:h-80 overflow-hidden [direction:ltr]">
                    <img src={ind.img} alt={ind.name} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F19]/60 to-transparent" />
                  </div>
                  <div className="p-8 sm:p-12 flex flex-col justify-center [direction:ltr]">
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 mb-5"><ind.icon className="w-6 h-6" /></span>
                    <div className="font-mono text-xs text-amber-400 mb-2">{ind.roles} Active Roles</div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight mb-3">{ind.name}</h2>
                    <p className="text-slate-400 leading-relaxed mb-6">{ind.desc} We maintain a living pipeline of pre-vetted professionals so we can move the moment your requirement lands.</p>
                    <Link to="/employers" className="inline-flex items-center gap-1.5 text-sm font-medium text-amber-400 hover:gap-2.5 transition-all">Hire in {ind.name.split(" ")[0]} <ArrowUpRight className="w-4 h-4" /></Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 border-y border-slate-800/80 bg-[#0d1220]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Stagger className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {[{ v: 6, s: "+", l: "Core Industries" }, { v: 480, s: "+", l: "Roles Filled / Year" }, { v: 92, s: "%", l: "First-Year Retention" }, { v: 48, s: "hr", l: "Avg. Shortlist Time" }].map((x) => (
              <StaggerItem key={x.l}><div className="font-accent text-4xl sm:text-5xl font-bold text-gradient-amber"><Counter value={x.v} suffix={x.s} /></div><div className="text-sm text-slate-500 mt-2">{x.l}</div></StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
